<template>
    <div class="">
        <b-overlay :show="loading" rounded="sm">

            <!-- Filters -->
            <div class="row mb-2">
                <div class="col-sm-5">
                    <!-- Field -->
                    <b-form-group label="Título">
                        <b-form-input
                            v-model="filter.title"
                            placeholder="Buscar por título ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-7">
                    <!-- Field -->
                    <b-form-group label="Modo de Correção">
                        <multiselect
                            v-model="filter.mode_id"
                            :options="modes"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Buscar por Modo de Correção ..."
                            tag-placeholder="Filtrar Modo de Correção"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há modos de correção disponíveis para exibir :(
                            </span>
                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <!-- Content -->
            <b-row>
                <b-col sm="6" v-for="theme in table" :key="theme.id">
                    <b-card
                        :title="theme.title"
                        :img-alt="theme.title"
                        :img-src="theme.preview"
                        class="mb-4 link"
                    >

                        <dl>
                            <dt>
                                Modo de Correção
                            </dt>
                            <dd>
                                {{ theme.mode.name }}
                            </dd>
                        </dl>

                        <dl>
                            <dt>
                                Criador por
                            </dt>
                            <dd>
                                {{ theme.author.name }} - {{ theme.created_at | moment('from', 'now') }}
                            </dd>
                        </dl>

                        <template #footer>

                            <a href="#" class="float-left" @click="previewTheme(theme)">
                                <i class="fa fa-eye mr-1"></i> Visualizar Tema
                            </a>

                            <a href="#" class="float-right" @click="attachThemeToOrganization(theme.id)">
                                <i class="fa fa-plus-square mr-1"></i> Adicionar Tema
                            </a>
                        </template>

                    </b-card>
                </b-col>
            </b-row>

            <!-- Empty -->
            <div v-if="table.length === 0 && !loading" class="bg-light p-4 text-center mb-3">
                Não encontramos nenhum resultado na busca :(
            </div>

            <!-- Paginate -->
            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @change="changePagination"
            />

        </b-overlay>

        <b-sidebar
            v-model="open"
            title="Detalhes do Tema"
            backdrop-variant="dark"
            width="690px"
            backdrop
            shadow
        >
            <div class="px-3 py-2" v-if="theme">

                <dl>
                    <dt>
                        Título
                    </dt>
                    <dd>
                        {{ theme.title }}
                    </dd>
                </dl>

                <dl>
                    <dt>
                        Modo de Correção
                    </dt>
                    <dd>
                        {{ theme.mode.name }}
                    </dd>
                </dl>

                <dl>
                    <dt>
                        Autor
                    </dt>
                    <dd>
                        {{ theme.author.name }} - {{ theme.created_at | moment('from', 'now') }}
                    </dd>
                </dl>

                <dl>
                    <dt>
                        Imagem de Capa
                    </dt>
                    <dd>
                        <img :src="theme.preview" class="img-thumbnail" />
                    </dd>
                </dl>

                <dl>
                    <dt>
                        Conteúdo
                    </dt>
                    <dd v-html="theme.content"></dd>
                </dl>

            </div>
        </b-sidebar>

    </div>
</template>

<script>

export default {
    components: {},
    props: ['endpointIndex', 'endpointAttach', 'modes'],
    data() {
        return {
            loading: false,
            table: [],
            perPage: 6,
            currentPage: 1,
            total: 0,
            sortBy: 'created_at',
            sortDesc: true,
            fields: [],
            filter: {
                title: null,
                mode_id: null
            },
            lastResultsCount: 5,
            theme: null,
            open: false,
        }
    },
    created() {
        this.load()
    },
    watch: {
        'filter.title': async function (value) {
            this.filter.title = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.mode_id': async function (value) {
            this.filter.mode_id = await value;
            this.currentPage = 1
            await this.load()
        },
    },
    methods: {

        load() {
            this.loading = true;
            axios.get(this.endpointIndex, {
                params: {
                    title: this.filter.title,
                    mode_id: this.filter.mode_id ? this.filter.mode_id.id : null,

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.themes.data
                    this.currentPage = response.themes.current_page
                    this.perPage = response.themes.per_page
                    this.total = response.themes.total

                    this.lastResultsCount = response.themes.data.length

                })
                .finally(() => this.loading = false)
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },

        attachThemeToOrganization(theme_id) {
            if (confirm('Deseja realmente adicionar o tema a sua organização atual ?')) {
                this.loading = true;
                axios.post(this.endpointAttach, {
                    theme_id: theme_id
                })
                    .then((result) => {

                        // Redirect
                        this.redirectIfNeed(result)

                        // Message
                        this.$toast.success('Tema adicionado com sucesso !')

                    })
                    .finally(() => this.loading = false)
            }
        },

        previewTheme(theme) {
            this.theme = theme;
            this.open = true;
        }

    }
}
</script>

<style scoped>

</style>
